import { FiX, FiCornerUpLeft } from "react-icons/fi";
import styles from "./ReplyPreview.module.css";

const ReplyPreview = ({ message, onCancel }) => {
  if (!message) return null;

  const preview = message.image && !message.text
    ? "📷 Photo"
    : message.isVoice
    ? "🎤 Voice message"
    : message.text?.slice(0, 80) + (message.text?.length > 80 ? "…" : "");

  return (
    <div className={styles.container}>
      <FiCornerUpLeft size={14} className={styles.icon} />
      <div className={styles.content}>
        <span className={styles.name}>{message.sender?.name}</span>
        <span className={styles.text}>{preview}</span>
      </div>
      {onCancel && (
        <button className={styles.cancel} onClick={onCancel} title="Cancel reply">
          <FiX size={14} />
        </button>
      )}
    </div>
  );
};

export default ReplyPreview;
